import React from 'react';

import { Control } from 'react-hook-form';

import { CombinedCustomerInfo } from '../../../../interfaces/Customer';
import { LbCreatableAutocomplete } from '../../../../../shared/components/form-components';
import { useGroupList } from '../../../../../customer-group';

type CustomerGroupSelectorProps = {
  control: Control<CombinedCustomerInfo>;
};

const CustomerGroupSelector = ({ control }: CustomerGroupSelectorProps) => {
  const { groupList } = useGroupList({ onlyActive: true });

  const generalInputProps = {
    control,
    size: 'small',
    variant: 'standard',
  } as const;

  const privateInfoProps = { InputProps: { className: 'private-info' } };

  return (
    <LbCreatableAutocomplete
      {...generalInputProps}
      {...privateInfoProps}
      name="customerGroup"
      label="User Group"
      options={groupList}
      labelKey="name"
      valueKey="id"
      prepareAddedOption={(label) => ({
        id: 0, // This is a fake id, need to know that this is a new group
        name: label,
        active: true,
        amountOfCustomers: 0,
      })}
    />
  );
};

export { CustomerGroupSelector };
